module.exports = __webpack_public_path__ + "img/drt9.3795363f.png";